<template>
	<div>
		<hero :content="heroContent" @hamburger="hamburgerClicked"></hero>
		<div class="clearfix">
			<voters class="voters col-xs-12"></voters>
		</div>
		<div class="clearfix">
			<critic-quote :criticSliderContent="criticSlider1" class="col-xs-12 no-pad"></critic-quote>
		</div>
		<div class="clearfix grid">
			<div class="cta-wrapper col-xs-12 col-md-6 hideme">
				<div class="cta hideme">
					<div class="cta-middle" v-on:click="goToUrl">Listen to score</div>
				</div>
			</div>
			<production-quote id="bestPictureProdQuote1" class="col-xs-12 col-md-6 no-pad" :prodQuote="productionQuote1"></production-quote>
		</div>
		<click-thru :clickThru="clickThru" @clickThru="nextCategory"></click-thru>
		<social></social>
		<legal></legal>
	</div>
</template>
<script>
import Hero from '../../components/Hero';
import Voters from '../../components/Voters';
import CriticQuote from '../../components/CriticQuote';
import ProductionQuote from '../../components/ProductionQuote';
import ClickThru from '../../components/ClickThru';
import Social from '../../components/Social';
import Legal from '../../components/Legal';

export default {
	name: 'best-original-score',
	data: function() {
		return {
			heroContent: {
				"image": "best-original-score-3b-lg",
				"mobileImage": "best-original-score-3b-mob",
				"superHeader": "For Your Consideration",
				"header": "BEST ORIGINAL SCORE",
				"subHeader": ['CARTER BURWELL'],
				"isSubPage": true
			},
			clickThru: {
				superHeader: 'Next Category',
				mainText: 'BEST CINEMATOGRAPHY',
				clickThruPath: ''
			},
			criticSlider1: [{
				text: 'Composer Carter Burwell further enhances the mood of ‘Three Billboards’ with his beautiful score, blending rural tunes with more classical and poetic leitmotifs.',
				author: '– SCREENRANT.COM'
			}, {
				text: 'Like the best movies often do, ‘Three Billboards’ leaves audiences with a complex set of emotions, and with a hard-to-define hint of the profound… something worthwhile and humane.',
				author: '- SAN FRANCISCO CHRONICLE'
			}],
			productionQuote1: {
				text: "Martin and I work entirely one-on-one, which isn’t always how it is in films. We talk everything through just the two of us and no one else enters the conversation so it’s an intimate kind of thing. For both of us, the focus was honing in on Mildred’s mix of fury, warmth and loss.",
				author: "- Carter Burwell"
			}
		}
	},
	components: {
		Hero,
		Voters,
		CriticQuote,
		ProductionQuote,
		ClickThru,
		Social,
		Legal
	},
	methods: {
		hamburgerClicked: function() {
			console.log('hamburger passing through BestProduction');
			this.$emit('hamburger');
		},
		nextCategory: function() {
			console.log('nextCategory at categorypage');
			this.$emit('clickThru')
		},
		goToUrl: function() {
			window.open("http://www.foxsearchlight.com/fyc/film/three-billboards-outside-ebbing-missouri/soundtrack/");
		}
	}
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// BestOriginalScore.vue?39ae2def